import { DraftState } from '@/types';
import { getViewFromConfiguration } from '@/model/configuration/getViewFromConfiguration';
import { getConfigurations } from '@/model/draft/getConfigurations';
import { getConfigurationsOnView } from '@/model/draft/getConfigurationsOnView';
import { getProductType } from '@/model/draft/getProductType';

const getErrorForConfiguration = (draft: DraftState, configurationId: number) =>
  draft.validation.errors[configurationId];

export const setSelectedAnyConfigurationWithErrorAction = (draft: DraftState) => {
  const selectedConfigurationError = getErrorForConfiguration(draft, draft.selectedConfigurationId);
  if (selectedConfigurationError) {
    // do nothing if the selected config already has errors
    return;
  }

  const configurationsWithErrors = getConfigurations(draft).filter(({ cid }) =>
    Boolean(getErrorForConfiguration(draft, cid))
  );

  if (configurationsWithErrors.length) {
    const configurationsWithErrorsOnCurrentView = getConfigurationsOnView(
      configurationsWithErrors,
      draft.view
    );
    if (configurationsWithErrorsOnCurrentView.length) {
      draft.selectedConfigurationId = configurationsWithErrorsOnCurrentView[0].cid;
    } else {
      const configuration = configurationsWithErrors[0];
      draft.selectedConfigurationId = configuration.cid;
      draft.view = getViewFromConfiguration(getProductType(draft), configuration);
    }
  }
};
